module.exports = __webpack_public_path__ + "img/diaceutics-logo--light.e66c25ba.svg";